import { alpha, Avatar, Button, IconButton, Link, Stack, Typography, useMediaQuery } from '@mui/material'
import { colorPalette } from '~/constants/styles/colors'
import { theme } from '~/lib/theme'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'

type StartGuideButtonProps = {
  variant?: 'contained' | 'outlined'
  absolutePositionTopRight?: boolean
  fixedPositionBottomRight?: boolean
  forceShowLabel?: boolean
}

export const StartGuideButton: React.FC<StartGuideButtonProps> = ({
  variant = 'contained',
  absolutePositionTopRight = false,
  fixedPositionBottomRight = false,
  forceShowLabel = false,
}) => {
  const isOutlined = variant === 'outlined'
  const isBreakpointDownSm = useMediaQuery(theme.breakpoints.down('sm'))
  const isBreakpointDownMd = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Link
      href={START_GUIDE_URL}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      sx={{
        zIndex: 100,
        ...(absolutePositionTopRight && {
          position: 'absolute',
          top: 28,
          right: 40,
        }),
        ...(fixedPositionBottomRight && {
          position: 'fixed',
          bottom: 20,
          right: 20,
        }),
      }}
    >
      {(isBreakpointDownSm && !forceShowLabel) || (isBreakpointDownMd && fixedPositionBottomRight) ? (
        <IconButton
          sx={{
            p: 0,
            backgroundColor: colorPalette.white,
            width: 32,
            height: 32,
            '&:hover': {
              backgroundColor: alpha(colorPalette.white, 0.9),
            },
          }}
        >
          <Avatar
            variant="circular"
            sx={{
              bgcolor: colorPalette.white,
              width: 32,
              height: 32,
              ...(fixedPositionBottomRight && {
                border: `1px solid ${colorPalette.success.outlineBorder}`,
              }),
            }}
          >
            🔰
          </Avatar>
        </IconButton>
      ) : (
        <Button
          variant={isOutlined ? 'outlined' : 'contained'}
          sx={{
            py: 0.3,
            backgroundColor: isOutlined ? 'transparent' : colorPalette.white,
            color: colorPalette.success.main,
            borderColor: isOutlined ? colorPalette.success.main : undefined,
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: isOutlined ? colorPalette.success.light : alpha(colorPalette.white, 0.9),
            },
          }}
          disableElevation
          size="small"
        >
          <Stack gap={1} direction="row" alignItems="center">
            <Typography fontSize={20}>🔰</Typography>
            <Typography fontWeight="bold" variant="body2">
              スタートガイド
            </Typography>
          </Stack>
        </Button>
      )}
    </Link>
  )
}

const START_GUIDE_URL = EXTERNAL_LINKS.START_GUIDE
